import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

class TabsTwo extends Component {
  handleTabClick = (event) => {
    const tab = event.currentTarget;

    if (window.innerWidth > 767) {
      return;
    }

    window.requestAnimationFrame(() => {
      tab.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    });
  };

  render() {
    let tab1 = "Main skills",
      tab2 = "AI workflow",
      tab3 = "Experience",
      tab4 = "Education & Certification";
    const { tabStyle } = this.props;
    return (
      <div>
        {/* Start Tabs Area */}
        <div className="tabs-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Tabs className="skill-tabs-shell">
                  <TabList className={`${tabStyle}`}>
                    <Tab onClick={this.handleTabClick}>{tab1}</Tab>
                    <Tab onClick={this.handleTabClick}>{tab2}</Tab>
                    <Tab onClick={this.handleTabClick}>{tab3}</Tab>
                    <Tab onClick={this.handleTabClick}>{tab4}</Tab>
                  </TabList>

                  <TabPanel>
                    <div className="single-tab-content">
                      <ul>
                        <li>
                          <a href="/#service">
                            Product Engineering <span> - React, TypeScript, Next.js</span>
                          </a>
                            Full-stack web applications, polished interfaces, server actions, APIs, and production deployment.
                        </li>
                        <li>
                          <a href="/#service">
                            AI-assisted Development <span> - Codex, Claude, n8n, OpenAI</span>
                          </a>
                          Custom skills, agent workflows, automation prototypes, and faster iteration without losing engineering control.
                        </li>
                        <li>
                          <a href="/#service">
                            Interactive Systems <span> - Three.js, React Three Fiber, D3.js</span>
                          </a>
                          3D art experiences, data visualization, semantic zoom, game systems, and mobile prototypes.
                        </li>
                        <li>
                          <a href="/#portfolio">
                            Web3 Development <span> - Solidity, Ethers.js, Ethereum</span>
                          </a>
                          Smart-contract prototypes, wallet-aware interfaces, blockchain experiments, and Three.js crypto visualizations.
                        </li>
                      </ul>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className="single-tab-content">
                      <ul>
                        <li>
                          <a href="https://codex-tooling.vercel.app/" target="_blank" rel="noreferrer">
                            Codex Tooling <span>- custom skills and service catalog</span>
                          </a>{" "}
                          Local source of truth for reusable Codex workflows, installers, web app templates, and Three.js guidance.
                        </li>
                        <li>
                          <a href="https://dev-offers.vercel.app/" target="_blank" rel="noreferrer">
                            Dev Offers <span>- agentic job-search dashboard</span>
                          </a>{" "}
                          Ingestion, normalization, deduplication, and scoring for freelance opportunities.
                        </li>
                        <li>
                          <a href="/#portfolio">
                            AI delivery practice <span>- faster product iteration</span>
                          </a>{" "}
                          AI is part of the workflow: planning, refactoring, code review, documentation, and repeatable project setup.
                        </li>
                      </ul>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className="single-tab-content">
                      <ul>
                        <li>
                        <a href="https://matis.art/" target="_blank" rel="noreferrer">
                            Freelance Developer<span> - Lausanne, Switzerland</span>
                          </a>{" "}
                          2023 - present: Givaudan, MATIS, Home of Management, AI workflows, 3D experiences, and product websites.
                        </li>
                        <li>
                          <a href="https://olympe.io/" target="_blank" rel="noreferrer">
                            Software Engineer<span> - Olympe.io</span>
                          </a>{" "}
                          2018 - 2023
                        </li>
                        <li>
                          <a href="https://thunderlotusgames.com/" target="_blank" rel="noreferrer">
                            Gameplay Developer<span> - Thunder Lotus </span>
                          </a>{" "}
                          2016 - 2017
                        </li>
                      </ul>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className="single-tab-content">
                      <ul>
                        <li>
                          <a href="https://www.polymtl.ca/" target="_blank" rel="noreferrer">
                            Software Engineering Bachelor
                            <span> - Polytechnique Montreal, Canada</span>
                          </a>{" "}
                          2011 - 2016
                        </li>
                        <li>
                          <a href="https://www.scrum.org/" target="_blank" rel="noreferrer">
                            Professional Scrum Master
                            <span> - Scrum.org</span>
                          </a>{" "}
                          2023
                        </li>
                        <li>
                          <a href="https://www.blockchain-council.org/" target="_blank" rel="noreferrer">
                            Solidity Certification
                            <span> - Blockchain Council</span>
                          </a>{" "}
                          2023
                        </li>
                      </ul>
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
        {/* End Tabs Area */}
      </div>
    );
  }
}

export default TabsTwo;
